<template>
  <div class="person-match">
    <a-tabs :activeKey="params.type" @change="handeChange">
      <template v-for="tab in tabs">
        <a-tab-pane :key="tab.value" :tab="tab.label"></a-tab-pane>
      </template>
    </a-tabs>
    <!-- 筛选条件 -->
    <a-row :gutter="30" style="padding-top:10px;" justify="space-between">
      <a-col span="6" style="margin-bottom:30px;">
        <a-row type="flex" align="top">
          <a-input-group compact>
            <a-select
              class="select"
              defaultValue="resume_name"
              @change="changeSelect1"
            >
              <a-select-option value="resume_name"
                >候选人姓名</a-select-option
              >
              <a-select-option value="resume_mobile">候选人电话</a-select-option>
            </a-select>
            <a-input
              style="width: 70%"
              placeholder="请输入关键字"
              v-model="selectValue1"
            />
          </a-input-group>
        </a-row>
      </a-col>
      <a-col span="6" style="margin-bottom:30px;">
        <a-row type="flex" align="top">
          <a-input-group compact>
            <a-select
              class="select"
              defaultValue="job_id"
              @change="changeSelect2"
            >
              <a-select-option value="job_id">职位ID</a-select-option>
              <a-select-option value="job_name">职位名</a-select-option>
            </a-select>
            <a-input
              style="width: 70%"
              placeholder="请输入关键字"
              v-model="selectValue2"
            />
          </a-input-group>
        </a-row>
      </a-col>
      <a-col span="6" style="margin-bottom:30px;">
        <a-row type="flex" align="top">
          <a-col span="4" class="form-label">负责BD</a-col>
          <a-col span="20">
            <a-auto-complete
              style="display:block"
              placeholder="请输入关键字"
              v-model="params.bd_user_id"
              :dataSource="BDList"
              @search="handleSearchBD"
              @select="changeBD"
            ></a-auto-complete>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="6" style="margin-bottom:30px;">
        <a-row type="flex" align="top">
          <a-col span="4" class="form-label">IE</a-col>
          <a-col span="20">
           <a-auto-complete
              style="display:block"
              placeholder="请输入关键字"
              v-model="params.ie_user_id"
              :dataSource="IEList"
              @search="handleSearchIE"
              @select="changeIE"
            ></a-auto-complete>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <!-- 筛选和统计 -->
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-button
          type="primary"
          style="margin-right:12px;padding:0 30px;"
          @click="handleFilter()"
          >筛选</a-button
        >
        <a-button style="margin-right:12px;" @click="resetParams"
          >清空筛选条件</a-button
        >
        <span>共找到 {{ total }} 条信息</span>
      </a-col>
      <a-col @click="goToSign">
        <a-button type="primary"><a-icon type="plus" />标记</a-button>
      </a-col>
    </a-row>
    <!-- 排序 -->
    <a-row type="flex" align="middle" justify="start" class="sort-bar">
      <template v-for="sort in sorts">
        <a-col span="3" class="sort" :key="sort.id" @click="changeSort(sort)">
          {{ sort.name }}
          <a-icon :type="selectSort.select && selectSort.id===sort.id?'arrow-up':'arrow-down'"></a-icon>
        </a-col>
      </template>
    </a-row>
    <!-- <div class="ant-divider ant-divider-horizontal"></div> -->
    
    <a-list
      itemLayout="vertical"
      :bordered="false"
      style="margin-top:30px"
      @change="getData"
      :loading="loading"
    >
      <template v-for="item in dataSource">
        <a-list-item :key="item.recommend_result_id">
          <a-row type="flex" align="top" justify="space-between">
            <a-col :span="11">
              <a-row type="flex" align="middle" :gutter="30">
                <!-- <a-col>
                  <a-avatar
                    style="width:66px;height:66px;line-height:66px;background:rgba(234,247,254);color:#8FD4FB;font-size:30px;"
                    size="large"
                    >{{ item.resume_detail.photo_url }}</a-avatar
                  >
                </a-col> -->
                <a-col style="width: 100%;">
                  <h3 class="flex">
                    <div class="go-resume" @click="$router.push('/resume/detail/' + item.resume_id)">
                      <b>{{ item.resume_name }}</b>
                      <span
                        style="color:#aaa;margin-left:18px; font-weight:400"
                        >{{ item.resume_mobile }}</span
                      >
                    </div>
                    <span @click="showHunter(item)" style="color:#aaa;margin-right:20px; font-weight:400">
                      <b class="hunter-name">{{ item.resume_detail.hunter_name }}</b> 于 
                      {{item.resume_detail.created_at + ' 贡献' }}
                    </span>
                  </h3>
                  <div>
                    <span>{{ item.resume_detail.last_company }}</span>
                  </div>
                  <p>
                    <span>{{ item.resume_detail.city }}</span>
                    <a-divider type="vertical" v-if="item.resume_detail.city"></a-divider>
                    <span>{{ item.resume_detail.work_years }}工作经验</span>
                    <a-divider type="vertical" v-if="item.resume_detail.city || item.resume_detail.work_years"></a-divider>
                    <span>{{ item.resume_detail.title }}</span>
                  </p>
                </a-col>
              </a-row>
            </a-col>
            
            <a-col :span="13" style="padding-left:35px;border-left:1px solid #ccc">
              <a-row type="flex" align="middle" :gutter="30">
                <!-- <a-col>
                  <a-avatar
                    style="width:62px;height:62px;"
                    :src="item.job_detail.logo_url || img"
                    size="large"
                    shape="square"
                  ></a-avatar>
                </a-col> -->
                <a-col style="width:100%; padding-left:0;">
                  <h3 class="flex">
                    <b class="go-job" style="display:inline-block;" @click="$router.push('/post-detail/' + item.job_id)">{{ item.job_id }}# {{
                      item.job_detail.name
                    }}</b>
                    <b style="color: red; "
                      >{{ item.job_detail.hunter_salary_min }}-{{
                        item.job_detail.hunter_salary_max
                      }}万</b
                    >
                    <span style="color:#aaa; font-weight:400">{{ item.job_detail.created_at }} 更新</span>
                  </h3>
                  <div>
                    <span>{{ item.job_detail.city }}</span>
                    <a-divider type="vertical" v-if="item.job_detail.city"></a-divider>
                    <span>招聘{{ item.job_detail.quantity }}人</span>
                    <a-divider type="vertical"></a-divider>
                    <span v-if="item.job_detail.experience_name">{{ item.job_detail.experience_name }}经验</span>
                    <a-divider type="vertical" v-if="item.job_detail.experience_name"></a-divider>
                    <span>{{ item.job_detail.education_name }}</span>
                  </div>
                  <p>
                    <span>
                      {{
                        item.job_detail.first_category_name
                          ? item.job_detail.first_category_name
                          : "" + "-" + item.job_detail.second_category_name
                          ? item.job_detail.second_category_name
                          : ""
                      }}
                    </span>
                    <a-divider type="vertical"></a-divider>
                    <span>{{ item.job_detail.name }}</span>
                  </p>
                </a-col>
              </a-row>
            </a-col>
          </a-row>

          <a-row
            type="flex"
            align="middle"
            justify="space-between"
            class="item-footer"
          >
            <a-col :span="10" v-if="params.type === 'undo'">匹配时间：{{ item.created_at }}</a-col>
            <a-col :span="20" v-if="params.type === 'reject'">{{ item.resume_detail.hunter_name }}丨拒绝理由：{{ item.reasons }}</a-col>
            <a-col :span="10" v-if="params.type === 'post'">
              {{ item.resume_detail.hunter_name }} 已做单丨订单编号：
              <span class="blue" @click="$router.push('/order/detail/' + item.post_id)">{{ item.post_id }}</span>
            </a-col>
            <a-col :span="params.type === 'reject'?4:10" style="padding-left:25px;" :align="params.type === 'reject'?'right':''">
              <h2>匹配度{{ item.match_degree }}%</h2>
            </a-col>
            <a-col class="btn-box" :span="4" v-if="params.type === 'undo'">
              <a-button class="cancel-btn" type="danger" @click="cancel(item)">不合适</a-button>
              <a-button class="order-btn" type="primary" @click="todoOrder(item)">做单</a-button>
            </a-col>
          </a-row>
        </a-list-item>
      </template>
    </a-list>

    <a-row
      type="flex"
      align="middle"
      justify="end"
      :style="{ padding: '30px 0' }"
    >
      <Pagination
        ref="pagination"
        :total="total"
        @change="getData"
      ></Pagination>
    </a-row>

    <!-- 做单组件-->
    <Recommend  ref="recommend" :callback="getData"></Recommend>
    <!-- 猎头组件-->
    <HunterModal ref="hunter"></HunterModal>
    <!-- 拒绝组件-->
    <RejectModal ref="rejectModal" @ok="getData()"></RejectModal>
    <!-- <resume-preview-modal ref="preview"></resume-preview-modal> -->
  </div>
</template>
<script>
import moment from "moment";
import Api from "@/api";
import RejectModal from "./components/RejectModal";
import HunterModal from "./components/HunterModal";
import Recommend from "@/components/recomend";
import baseComponentVue from "@/components/base-component.vue";
import Pagination from "@/components/Pagination";

const sorts = [
  {
    name: "匹配时间",
    id: 0,
    value: "match_time asc",
    _value: "match_time desc",
    select: false,
  },
  {
    name: "匹配度",
    id: 1,
    value: "match_degree asc",
    _value: "match_degree desc",
    select: false,
  }
];

export default {
  name: "RelationshipCash",
  extends: baseComponentVue,
  data() {
    return {
      sorts,
      selectSort: {
        name: "匹配时间",
        id: 0,
        value: "match_time asc",
        _value: "'match_time desc",
        select: false,
      },
      tabs: Object.freeze([
        { label: "待处理", value: "undo" },
        { label: "已拒绝", value: "reject" },
        { label: "已做单", value: "post" }
      ]),
      loading: false,
      dataSource: [],
      columns: [],
      total: 0,
      pagination: null,
      BDList: [],
      IEList: [],
      selectOption1: 'name',
      selectOption2: 'job_id',
      selectValue1: '',
      selectValue2: '',
      bd_user_id: '',
      ie_user_id: '',
      params: {
        type: 'undo', // 类型
        ie_user_id: '',
        bd_user_id: ''
      },
      img: require("@/assets/defaultLogo.png")
    };
  },
  components: {
    HunterModal,
    RejectModal,
    Recommend,
    Pagination
  },
  mounted() {
    this.resetParams();
    this.pagination = this.$refs.pagination;
    this.getData();
  },
  methods: {
    async handleSearchBD(value) {
      if (!value) return;
      let response = await Api.hrlist.searchBD({ name: value });
      let arr = [];
      response.forEach(item => {
        arr.push({ value: item.uid, text: item.name });
      });
      this.BDList = arr;
    },
    changeBD(value) {
      this.params.bd_user_id = value;
    },
    async handleSearchIE(value) {
      if (!value) return;
      let response = await Api.account.suggest({ name: value });
      let arr = [];
      response.forEach(item => {
        arr.push({ value: item.uid, text: item.name });
      });
      this.IEList = arr;
    },
    changeIE(value) {
      this.params.ie_user_id = value;
    },
    handleFilter() {
      this.params[this.selectOption1] = this.selectValue1;
      this.params[this.selectOption2] = this.selectValue2;
      this.getData();
    },
    resetParams() {
      let params = {
        type: 'undo', // 类型
      };
      this.selectOption1 = 'resume_name';
      this.selectOption2 = 'job_id';
      this.selectValue1 = '';
      this.selectValue2 = '';
      params[this.selectOption1] = this.selectValue1;
      params[this.selectOption2] = this.selectValue2;
      this.params = { ...params };
    },
    changeSort(sort) {
      if(this.selectSort.id === sort.id) {
        this.selectSort.select = !this.selectSort.select;
        this.params.order = sort._value;
      } else {
        this.selectSort = sort;
        this.selectSort.select = true;
        this.params.order = sort.value;
      }
      this.getData();
    },
    changeSelect1(val) {
      console.log(val, 'selectValue1');
      delete this.params[this.selectOption1];
      this.selectValue1 = '';
      this.selectOption1 = val;
      this.params[val] = this.selectValue1;
    },
    changeSelect2(val) {
      delete this.params[this.selectOption2];
      this.selectValue2 = '';
      this.selectOption2 = val;
      this.params[val] = this.selectValue2;
    },
    handeChange(val) {
      this.params.type = val;
      this.getData();
    },
    async getData(pagination) {
      this.loading = true;
      let params = {
        ...this.params,
        page: this.pagination.current,
        page_size: this.pagination.pageSize
      };
      console.log(params);
      if (!pagination) {
        this.pagination.current = 1;
        params.page = 1;
        this.pagination.pageSize = 10;
        params.page_size = 10;
      } else {
        params.page = pagination.current;
        params.page_size = pagination.pageSize;
      }
      let response = await Api.hunter.getRecommendList(params);
      let { list, job_detail, resume_detail } = await Api.hunter.getRecommendList(params);
      this.loading = false;
      this.total = +response.total;
      this.dataSource = response.list;
    },
    async showHunter(item) {
      let params = { user_id: item.resume_detail.hunter_uid};
      let response = await Api.hunter.getHunterInfo(params);
      let hunterInfo = response.user;
      this.$refs.hunter.show(hunterInfo);
    },
    cancel(item) {
      console.log(item);
      let { rejectModal } = this.$refs;
      rejectModal.show(item.recommend_result_id);
    },
    async todoOrder(item) {
      let res = await Api.post.checkPost({
        resume_id: item.resume_id,
        job_id: item.job_id
      });
      if (res.result == 1) {
        let { resume } = await Api.position.resumeDetails({
          resume_id: item.resume_id
        });
        let that = this;
        if (res.same_resume_name == 1) {
            this.$confirm({
            content: '系统检测到该职位已有猎头推荐同名候选人，疑似重复推荐！',
            okText: '继续推荐',
            cancelText: '取消',
            onOk() {
               that.$refs.recommend.show(resume, item.job_id, item.job_detail.name, item.recommend_result_id);
            },
            onCancel() { return;},
            });
        }else{
            that.$refs.recommend.show(resume, item.job_id, item.job_detail.name, item.recommend_result_id);
        }
      } else {
        this.$message.info("该人脉已经投递，请尝试其他人脉数据做单");
      }
    },
    goToSign() {
      this.$router.push({
        name: 'RecommendSign'
      })
    }
  }
};
</script>

<style scoped lang="scss">
.person-match {
  p {
    margin: 0;
    margin-top: 9px;
  }
  ::v-deep .ant-list-item {
    margin-top: 20px;
    border: 1px solid rgba(228, 232, 235, 1);
    padding: 20px;
  }
  ::v-deep .ant-list-vertical .ant-list-item-content {
    margin: 0;
  }
  .item-footer {
    padding-top: 16px;
    margin-top: 20px;
    border-top: 1px solid rgba(228, 232, 235, 1);
    h2 {
      color: #35b5fe;
      margin: 0;
      padding: 0;
    }
    .btn-box {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .cancel-btn {
        margin-right: 20px;
      }
    }
  }
  
  .sort-bar {
    text-align: center;
    margin-top: 20px;
    border-radius: 3px;
    background: #35b5fe;
    border: 1px solid rgba(228, 232, 235, 1);
    .sort {
      cursor: pointer;
      font-size: 16px;
      height: 48px;
      line-height: 48px;
      color: #ffffff;
      &.active {
        color: #35b5fe;
      }
    }
  }
  .hunter-name {
    cursor: pointer;
    color: #35b5fe;
  }
  .blue {
    color: #35b5fe;
    cursor: pointer;
  }
  .flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .go-resume, .go-job {
    cursor: pointer;
  }
}
</style>
